import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { defaultNavigationOptions } from '../../../entities/navigation/navigation-options.entity';

import { RecordSandboxService } from '../../sandbox/record-sandbox.service';

@Injectable()
export class VersionedRecordResolverService {
    constructor(
        private router: Router,
        private readonly sandbox: RecordSandboxService
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        const recordId = route.params.recordId;
        const queryParams = route.queryParams;
        // First try to navigate to head (=published) version
        return this.sandbox
            .navigateByIdAndVersion(recordId, 'head', { ...defaultNavigationOptions, queryParams, hideToasts: true })
            .pipe(
                switchMap(isNavigationSuccesfull => {
                    if (isNavigationSuccesfull) {
                        return of(isNavigationSuccesfull);
                    }
                    // If navigation to head doesn't work (because series hasn't been published yet), navigate to latest
                    return this.sandbox.navigateByIdAndVersion(recordId, 'latest', {
                        ...defaultNavigationOptions,
                        queryParams
                    });
                }),
                switchMap(isNavigationSuccesfull => {
                    if (isNavigationSuccesfull) {
                        return of(isNavigationSuccesfull);
                    }
                    // If navigation to by versioning does not work fallback to normal navigation by record id
                    return this.sandbox.navigateById(recordId, { ...defaultNavigationOptions, queryParams });
                }),
                tap(isNavigationSuccesfull => {
                    if (!isNavigationSuccesfull) {
                        this.navigateToDashboard();
                        this.showNavigationFailedToast();
                    }
                })
            );
    }

    private navigateToDashboard(): void {
        this.router.navigate(['/']);
    }

    private showNavigationFailedToast(): void {
        this.sandbox.addWarning('reference-code.errors.could-not-navigate');
    }
}
